import queryString from 'query-string'

import config from 'config/index'
import {
  GOOGLE_REDIRECT_URI,
  MICROSOFT_REDIRECT_URI,
} from 'layouts/SignUpStep/constants'

export const redirectToMicrosoftLogin = () => {
  const params = {
    response_type: 'code',
    response_mode: 'query',
    redirect_uri: MICROSOFT_REDIRECT_URI,
    client_id: config.MICROSOFT_CALENDAR_CLIENT_ID,
    scope: 'openid profile email offline_access User.Read Calendars.ReadWrite',
  }
  window.location.href = `${
    config.MICROSOFT_OAUTH_BASE_URL
  }?${queryString.stringify(params)}`
}

export const redirectToGoogleLogin = () => {
  const params = {
    response_type: 'code',
    response_mode: 'query',
    redirect_uri: GOOGLE_REDIRECT_URI,
    client_id: config.GOOGLE_CLIENT_ID,
    access_type: 'offline',
    scope: 'https://www.googleapis.com/auth/calendar openid profile email',
  }
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${queryString.stringify(
    params
  )}`
}
